document.addEventListener("DOMContentLoaded", function () {
  const cookies = document.cookie.split("; ");
  const hasVisited = cookies.find((row) => row.startsWith("first_time_visitor"));
  const hasInteracted = cookies.find((row) => row.startsWith("wishlist_interaction"));
  const isLoggedIn = !!window.__st?.cid || document.cookie.includes("_shopify_customer");

  // Only show if: first visit AND hasn't interacted before AND not logged in
  if (!hasVisited && !hasInteracted && !isLoggedIn) {
    document.cookie = "first_time_visitor=true; path=/; max-age=31536000";
    document.getElementById("wishlist-popup").style.display = "flex";
  }

  document
    .getElementById("wishlist-yes")
    .addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      closePopup();
      setInteractionCookie();
    });

  document
    .getElementById("wishlist-no")
    .addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      document.getElementById("wishlist-question").style.display = "none";
      document.getElementById("signup-form").style.display = "block";
    });

  document
    .getElementById("create-account-form")
    .addEventListener("submit", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const firstName = document.getElementById("first-name").value;
      const lastName = document.getElementById("last-name").value;
      const email = document.getElementById("email").value;
      const password = document.getElementById("password").value;

      fetch("https://beat-goes-on.myshopify.com/api/2024-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "f3d55e9b4c7882389fce9f639a2be6cb",
        },
        body: JSON.stringify({
          query: `
                mutation customerCreate($input: CustomerCreateInput!) {
                    customerCreate(input: $input) {
                        customer {
                            id
                            email
                        }
                        customerUserErrors {
                            code
                            field
                            message
                        }
                    }
                }`,
          variables: {
            input: {
              firstName: firstName,
              lastName: lastName,
              email: email,
              password: password,
              acceptsMarketing: true,
            },
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Response from customerCreate:", data);
          if (data.data.customerCreate.customer) {
            console.log(
              "Customer created successfully:",
              data.data.customerCreate.customer
            );
            closePopup();
            setInteractionCookie();
          } else {
            console.error(
              "Error creating account:",
              data.data.customerCreate.customerUserErrors
            );
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });

  document
    .getElementById("close-popup")
    .addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      closePopup();
      setInteractionCookie();
    });

  document
    .getElementById("wishlist-popup")
    .addEventListener("click", function (event) {
      event.stopPropagation();
    });

  document
    .querySelector(".popup-content")
    .addEventListener("click", function (event) {
      event.stopPropagation();
    });
});

function closePopup() {
  document.getElementById("wishlist-popup").style.display = "none";
}

function setInteractionCookie() {
  document.cookie = "wishlist_interaction=true; path=/; max-age=31536000";
}
